<template>
  <div>
    <div class="footer-on">
      <div class="wrap">
        <Row>
          <Col span="11"
               class="footer-on-left">
          <img class="logo"
               style="width:164px;heigth:63px;margin-left:68px;"
               src="../assets/images/footer/logo.png"
               alt="" />
<!--          <img class="logo"-->
<!--               style="width:161px;heigth:60px;"-->
<!--               src="../assets/images/footer/logo1.png"-->
<!--               alt="" />-->
          <!-- <h4 class="footer-company">北京威马捷国际旅行援助有限责任公司</h4> -->
          </Col>
          <Col span="13">
          <!--<Row>
            <Col span="9"
                 class="text-center">
            <img class="contact-phone"
                 src="../assets/images/footer/call_me.png"
                 alt="" />
            <p class="contact-us">联系我们</p>
            </Col>
            <Col span="15">
            <p class="contact-info">
              <span>联系电话： </span>
              <span>010-85927001</span>
            </p>
            <p class="contact-info">
              <span>公司地址：</span>
              <span>北京市朝阳区东四环中路56号<br/>远洋国际中心A座23层03-05</span>
            </p>
            <p class="contact-info">
              <span>邮　　编：</span>
              <span>100025</span>
            </p>
            </Col>
          </Row>-->
            <img class="logo"
                 style="width: 560px;height: 126px;backface-visibility:hidden;-webkit-backface-visibility:hidden;"
                 src="../assets/images/footer/companyInfo.png"
                 alt="" />
          </Col>
        </Row>
        <router-link v-show="flag"
                     target="_blank"
                     to="/submitQues"
                     class="foot-submit">请求资料/提交问题
          <span></span>
        </router-link>
      </div>
    </div>
    <div class="footer-btm">
      <div class="wrap">
        <div class="footer-link">
          <span v-for="(item,index) in homeNavList"
                :key="index">
            <router-link :to="item.path"
                         target="_blank">
              {{item.name}}
            </router-link>
            <Divider v-if="index<homeNavList.length-1"
                     type="vertical" />
          </span>
        </div>
        <div class="footer-link">
          <span v-for="(item,index) in overseasNavList"
                :key="index">
            <router-link :to="item.path"
                         target="_blank">
              {{item.name}}
            </router-link>
            <Divider v-if="index<overseasNavList.length-1"
                     type="vertical" />
          </span>
        </div>
        <!-- <p class="footer-info">北京威马捷国际旅行援助有限责任公司</p> -->
        <p class="footer-info">Copyright2021-2025 All Rights Reserved 版权所有：北京威马捷国际旅行援助有限责任公司
          <a href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action">京ICP备19036142号</a>
          (京)网药械信息备字(2024)第00034号
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { homeNavList, overseasNavList } from "@/config/headNav.js"
export default {
  data () {
    return {
      redirect: null,
      flag: true,
      homeNavList: [],
      overseasNavList: []
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        let path = this.$route.path
        if (path == "/" || path == "/home" || path.indexOf('/rescue') > -1 ||
             path == "/about" || path == '/activities' || path == '/assistances') {
          this.flag = true;
        } else {
          this.flag = false;
        }
      },
      immediate: true
    }
  },
  created () {
    let url = this.$route.query;
    this.homeNavList = homeNavList
    this.overseasNavList = overseasNavList
    // console.log('url:',url)
  },
  mounted () {

  },
}
</script>
<style lang="less" scoped>
.footer-on {
  position: relative;
  z-index: 99;
  background: #3c3c3c;
  padding: 84px 0 74px;
}
.footer-btm {
  position: relative;
  z-index: 99;
  background: #303030;
  padding: 42px 0 30px;
}
.wrap {
  width: 1100px;
  margin: 0 auto;
  text-align: center;
}
.footer-on-left {
  border-right: 1px dashed #c0c0c0;
  text-align: left;
  img {
    margin: 18px 0;
  }
}
.logo {
  width: 158px;
  height: 60px;
}
.footer-company {
  color: #c0c0c0;
  font-size: 18px;
  font-weight: normal;
  line-height: 24px;
}
.contact-phone {
  width: 44px;
  height: 44px;
  margin-bottom: 9px;
  margin-top: 10px;
}
.contact-us {
  font-size: 16px;
  color: #c0c0c0;
  // line-height: 36px;
}
.contact-info {
  font-size: 15.5px;
  color: #c0c0c0;
  line-height: 20px;
  // margin-bottom: 5px;
  text-align: left;
  line-height: 28px;
  display: table;
  span:first-child {
    width: 78px;
    float: left;
  }
  span:last-child {
    width: 215px;
    float: left;
  }
}
.footer-link {
  margin-bottom: 20px;
  display: inline-block;
}
.footer-link a {
  font-size: 14px;
  color: #c0c0c0;
  line-height: 18px;
  margin: 0 12px;
}
.footer-link a:hover {
  color: #999;
  text-decoration: underline;
}
.ivu-divider {
  background: #656565;
}
.footer-info {
  font-size: 12px;
  color: #c0c0c0;
  line-height: 14px;
  text-align: center;
  margin-bottom: 16px;
  margin-top: 20px;
}
.foot-submit {
  position: relative;
  display: block;
  width: 722px;
  height: 98px;
  border: 1px solid #7e2b22;
  background: #fff;
  font-size: 30px;
  color: #ae1e10;
  line-height: 98px;
  text-align: center;
  margin: 86px auto 0 auto;
  span {
    position: absolute;
    top: 44%;
    right: 37px;
    transform: translateY(-50%);
    width: 16px;
    height: 16px;
    border-top: 2px solid #ae1e10;
    border-right: 2px solid #ae1e10;
    transform: rotate(45deg);
  }
}
.foot-submit:hover {
  background: #ae1e10;
  color: #fff;
  transition: 0.3s linear;
}
.foot-submit:hover span {
  border-top: 2px solid #fff;
  border-right: 2px solid #fff;
  transition: 0.3s linear;
}
</style>